export const DATE_SEPARATOR = '-';

export const TEST_ID = 'dateRangePickerInputs';
